// «متكرر» — this guest has 2+ bookings with us (tasks/inbox-returning-guest-badge.md).
//
// The server decides who qualifies (`conversation.repeatGuest`, same count and threshold as the
// Guests page); this component only renders what it is given, so there is no threshold here to drift.
//
// Two forms, because the two places it sits behave differently:
//   - ROW: plain label. The whole row is already a <button>; a link inside it is invalid HTML and
//     would steal the tap that opens the thread.
//   - HEADER: a link to the guest profile, with the count. The header is not itself clickable, so this
//     is where the way through belongs — the same reasoning the booking-ref link follows.

import React from 'react';
import { Link } from 'react-router-dom';
import { formatCount } from '../../utils/numberFormatter';

// Arabic counts: 2 takes the dual, 3–10 the plural, 11+ the singular accusative.
const bookingsLabel = (n) => {
  if (n === 2) return 'حجزان';
  if (n <= 10) return `${formatCount(n)} حجوزات`;
  return `${formatCount(n)} حجزاً`;
};

const RepeatGuestBadge = ({ repeatGuest, linked = false }) => {
  if (!repeatGuest) return null;

  if (!linked) {
    return (
      <span className="inbox-repeat-badge" title={`ضيف متكرر — ${bookingsLabel(repeatGuest.totalBookings)}`}>
        <i className="bi bi-arrow-repeat" aria-hidden="true"></i>
        متكرر
      </span>
    );
  }

  return (
    <Link
      to={`/guests/${repeatGuest.id}`}
      className="inbox-repeat-badge is-link"
      aria-label={`ضيف متكرر، ${bookingsLabel(repeatGuest.totalBookings)} — فتح ملف الضيف`}
    >
      <i className="bi bi-arrow-repeat" aria-hidden="true"></i>
      متكرر · {bookingsLabel(repeatGuest.totalBookings)}
    </Link>
  );
};

export default RepeatGuestBadge;
